<template>
  <v-card style="width: 100%; height: 100%;">
    <v-container fluid grid-list-md fill-height style="padding-top: 8px;">
      <v-flex id="maintenance_tasks_table" d-flex md12 style="height: 100%">
        <dx-data-grid
            class="grid collapsable"
            :style="`width: 100%; height: 100%; max-height:${tableHeight}`"
            :data-source="tasksDataSource"
            :remote-operations="true"
            :show-column-lines="true"
            :show-row-lines="true"
            :show-borders="true"
            :word-wrap-enabled="true"
            :row-alternation-enabled="false"
            :column-auto-width="true"
            @selection-changed="eventSelected"
            @content-ready="contentReady"
        >
          <DxSelection mode="single"/>
          <DxHeaderFilter :visible="false"/>
          <DxFilterRow :visible="true"/>
          <dx-column
              :filter-operations="['contains']"
              alignment="center"
              data-field="engine"
              caption="Engine"
          />
          <dx-column
              :filter-operations="['contains']"
              alignment="center"
              data-field="component"
              caption="Component"
          />
          <dx-column
              :filter-operations="['contains']"
              alignment="center"
              data-field="c_rh"
              caption="Current RH"
          />
          <dx-column
              :filter-operations="['contains']"
              alignment="center"
              data-field="action"
              caption="M. Action"
          />
          <dx-column
              :filter-operations="['contains']"
              alignment="center"
              data-field="pl_rh"
              caption="Planned RH"
          />
          <dx-column
              :filter-operations="['contains']"
              alignment="center"
              data-field="pr_rh"
              caption="Predicted RH"
          />
          <dx-column
              :filter-operations="['contains']"
              alignment="center"
              data-field="com_rh"
              caption="Completion RH"
          />
          <dx-column
              :allowHeaderFiltering="false"
              :allowFiltering="false"
              :filter-operations="[]"
              alignment="center"
              data-field="verified"
              data-type="boolean"
              caption="Status"
              cell-template="verifiedTemp"
              :minWidth="'150px'"
              :width="'150px'"
              :maxWidth="'150px'"
              :allowSorting="false"
          />
<!--          <dx-column-->
<!--              :allowHeaderFiltering="false"-->
<!--              :allowFiltering="false"-->
<!--              :filter-operations="[]"-->
<!--              alignment="center"-->
<!--              caption="RH Timeline"-->
<!--              cell-template="RHChart"-->
<!--              :allowSorting="false"-->
<!--              cssClass="align_bottom"-->
<!--          />-->

          <div slot="verifiedTemp" slot-scope="{data}">
            <span>{{ getStatus(data.data.acknowledged) }}</span>
          </div>

<!--          <div slot="RHChart" slot-scope="{data}">-->
<!--            <span>{{ getStatus(data.data.acknowledged) }}</span>-->
<!--          </div>-->

          <DxMasterDetail
              :enabled="false"
              template="detailsTemplate"
          />

          <template #detailsTemplate="{}">
            <v-layout row style="height: 100%">
              <v-flex d-flex md9 style="height: 250px">
                <TimelineChart
                    v-bind:active="true"
                    v-bind:chartOptions="createChartForSelectedRow()"
                    v-bind:title="'Running Hours'"
                    v-bind:maximize-callback="maximizeRHGraph"
                />
              </v-flex>
<!--              <v-flex d-flex md4 style="height: 250px">-->
<!--                <TimelineChart v-bind:active="true" v-bind:chartOptions="chartData['kpis']" v-bind:title="'Related KPIs'"/>-->
<!--                &lt;!&ndash;                <Chart v-bind:chartOptions="chartData['kpis']" v-bind:title="'Related KPIs'" v-bind:active="true"/>&ndash;&gt;-->
<!--              </v-flex>-->
              <v-flex d-flex md3 style="height: 250px">
                <v-card fill-height style="height:100%;width:100%;">
                  <v-card-title primary class="title" style="height:15%;width:100%;padding-top:5px;padding-bottom:5px;">Completion details</v-card-title>
                  <v-card-actions ref="chartContainer" fill-height style="height:85%;width:100%;padding-top:0px;padding-bottom:0px;padding-left:1.25rem;">
                    <v-layout column style="height: 100%">
                      <v-layout row>
                        <v-flex md2>Date:</v-flex>
                        <v-flex md10> -</v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex md2>Condition:</v-flex>
                        <v-flex md10> -</v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex md2>Replacement:</v-flex>
                        <v-flex md10> -</v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex md2>Comment:</v-flex>
                        <v-flex md10> -</v-flex>
                      </v-layout>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </template>
        </dx-data-grid>
      </v-flex>
      <v-dialog v-model="rhGraphModal" width="1420" :style="'height: 900px; max-height: 900px;'">
        <v-card style="width:100%;height: 900px; max-height: 800px">
          <v-card-title primary class="title" style="height:10%; padding-top: 0; padding-bottom: 0;">Running Hours</v-card-title>
          <v-card-text style="height:90%; padding-top: 0;">
            <div
                :id="'rhModalTabsContainer'"
                :style="
                  'width:100%; ' +
                  'overflow-y:auto; ' +
                  'padding: 0 16px;'
                "
            >
              <TimelineChart
                  v-bind:active="true"
                  v-bind:chartOptions="maximizeChartData"
                  v-bind:title="''"
                  v-bind:free="true"
              />
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </v-card>
</template>

<script>
import {DxColumn, DxDataGrid, DxFilterRow, DxHeaderFilter, DxMasterDetail, DxPaging, DxSelection} from "devextreme-vue/data-grid";
import TimelineChart from '../controls/TimelineChart'
import {createStore} from "devextreme-aspnet-data-nojquery";
import {globalStore} from "../main.js"
import axios from "axios";

export default {
  name: "MaintenanceTasks",
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxFilterRow,
    DxHeaderFilter,
    DxMasterDetail,
    DxSelection,
    TimelineChart
  },
  data() {
    return {
      tableHeight: '0px',
      tasksDataSource: null,
      status_items: [
        {
          'value': -1,
          'color': 'white',
          'label': 'Pending'
        },
        {
          'value': 0,
          'color': 'red',
          'label': 'Rejected'
        },
        {
          'value': 1,
          'color': 'green',
          'label': 'Approved'
        }
      ],
      rh_limit: 8000,
      chartData: {
        'kpis': {
          chart: {
            height: 0,
          },
          exporting: {
            enabled: false
          },
          title: {
            text: undefined
          },
          plotOptions: {
            pie: {
              shadow: false,
              center: ['50%', '50%'],
              dataLabels: {
                enabled: true,
                formatter: function () {
                  return `${this.point.name}: ${this.point.y}%`
                }
              }
            }
          },
          series: [{
            type: 'pie',
            animation: false,
            data: [
              {
                'name': 'KPI 1',
                'y': 25
              },
              {
                'name': 'KPI 2',
                'y': 12.5
              },
              {
                'name': 'KPI 3',
                'y': 12.5
              },
              {
                'name': 'KPI 4',
                'y': 25
              },
              {
                'name': 'KPI 5',
                'y': 25
              }
            ],
            size: '100%',
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          }],
          tooltip: {
            formatter: function () {
              return this.point.name + ': ' + this.point.y.toFixed(1);
            }
          },
          credits: {enabled: false}
        }
      },
      selectedTaskChart: {
        chart: {
          height: 0,
          title: ''
        },
        exporting: {
          enabled: false
        },
        title: {
          text: ''
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false
            },
          }
        },
        series: [
          {
            name: "Standard running hours",
            animation: false,
            data: [],
            size: '100%',
            innerSize: '70%',
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          },
          {
            name: "Usage-based running hours",
            animation: false,
            data: [],
            size: '100%',
            innerSize: '70%',
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          },
          {
            name: "Overhaul interval",
            animation: false,
            data: [],
            size: '100%',
            innerSize: '70%',
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          }
        ],
        xAxis: {
          type: 'datetime',
          title: {
            text: 'Time',
            align: 'high'
          },
          crosshair: true
        },
        yAxis: {
          title: {
            text: 'Running Hours',
            align: 'high'
          },
        },
        tooltip: {
          shared: true,
        },
        credits: {enabled: false}
      },
      rhGraphModal: false,
      maximizeChartData: {},
      maximizeDetailedChartData: {
        chart: {
          height: 0,
        },
        exporting: {
          enabled: false
        },
        title: {
          text: ''
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false
            },
          }
        },
        series: [],
        xAxis: {
          type: 'datetime',
          title: {
            text: 'Time',
            align: 'high'
          },
          crosshair: true
        },
        yAxis: [
          {
            title: {
              text: 'Running Hours',
              align: 'high'
            },
            height: '45%'
          },
          {
            title: {
              text: 'Running Hours',
              align: 'high'
            },
            top: '55%',
            height: '45%',
            offset: 0
          }
        ],
        tooltip: {
          shared: true,
        },
        credits: {enabled: false}
      },
      screen: 'table',
      selectedDetailedView: false,
      signals: null,
      details_loading: true,
      disable_edit_signals_btn: false,
      edit_visible_signals: false,
      available_signals: {},
      available_signals_holders: [],
      selected_signals: [],
      selected_signals_bp: []
    }
  },
  methods: {
    getPeriod() {
      let period;

      switch (globalStore.type) {
        case 'month':
          period = '1month'
          break;
        case 'threemonths':
          period = '3months'
          break;
        case 'sixmonths':
          period = '6months'
          break;
        case 'twelvemonths':
          period = '12months'
          break;
      }

      return period;
    },
    getStatus: function (status) {
      return this.status_items.filter((item) => {
        return item.value == status
      })[0]['label']
    },
    setTasksDataSource: function () {
      let params = {};

      if (typeof this.selected_id != 'undefined') {
        params['id'] = this.selected_id;
      }

      this.tasksDataSource = createStore({
        loadUrl: `${globalStore.config.api_location}/maintenance/tasks/approved`,
        loadMethod: "POST",
        loadParams: params,
        onLoading: (options) => {
          globalStore.loading = false;
        },
        onLoaded: (data) => {
          globalStore.loading = false;
        },
        onAjaxError: (e) => {
          globalStore.loading = false;
        }
      });
    },
    eventSelected: function (e) {
      e.component.collapseAll(-1);
      this.selectedVesselRow = e.currentSelectedRowKeys[0];

      e.component.expandRow(this.selectedVesselRow);
    },
    contentReady: function (e) {
      let selected = e.component.getSelectedRowKeys(),
          lookup = e.component.getVisibleRows().filter((row) => {
            return row.data == selected[0]
          });

      if (!e.component.getSelectedRowKeys().length || !lookup.length) {
        e.component.selectRowsByIndexes(0);
      }
    },
    createChartForSelectedRow: function () {
      let chart = JSON.parse(JSON.stringify(this.selectedTaskChart))
      chart.series[0].data = this.selectedVesselRow.events.calculated.values
      chart.series[1].data = this.selectedVesselRow.events.predicted.values
      chart.series[2].data = this.selectedVesselRow.events.overhaul_threshold.values

      return chart;
    },
    setTableHeight() {
      let height = (window.outerHeight / 12 * 12).toFixed(0);
      this.tableHeight = height + 'px !important';
    },
    maximizeRHGraph(data) {
      let series = JSON.parse(JSON.stringify(data.series));

      for (var i in series) {
        if (series.hasOwnProperty(i)) {
          series[i].yAxis = 1;
        }
      }

      this.maximizeChartData = JSON.parse(JSON.stringify(data))
      this.maximizeChartData['title'] = {
        text: '',
        align: 'right',
        x: -10
      }
      this.rhGraphModal = true;

      setTimeout(() => {
        this.maximizeChartData['chart']['zoomType'] = 'xy';
        this.maximizeChartData['chart']['width'] = 1420 * 0.95;
        this.maximizeChartData['chart']['height'] = 800 * 0.80;
        this.maximizeDetailedChartData['chart']['zoomType'] = 'xy';
        this.maximizeDetailedChartData['chart']['width'] = 1420 * 0.95;
        this.maximizeDetailedChartData['chart']['height'] = 800 * 0.80;
      }, 1)

      this.loadDataDetails();
    },
    loadDataDetails(signals) {
      this.details_loading = true;

      this.selected_signals = [];

      return axios.post(globalStore.config.api_location + `/maintenance/tasks/${this.selectedVesselRow.id}/data`, {signals: signals}).then((res) => {
        if (res.data.success) {
          let tmp_signals = {}

          this.available_signals = res.data.data.available_signals;

          Object.keys(res.data.data.details.signals).map((parameter) => {
            if (this.selected_signals.indexOf(this.available_signals[parameter]) < 0) {
              this.selected_signals.push(this.available_signals[parameter])
            }

            res.data.data.details.signals[parameter].values.map((pair) => {
              let parameter_title = res.data.data.details.signals[parameter].title;
              tmp_signals[pair[0]] = tmp_signals[pair[0]] || {}
              tmp_signals[pair[0]]['date'] = new Date(pair[0])
              tmp_signals[pair[0]][parameter_title] = pair[1];
            });
          });

          this.signals = Object.values(tmp_signals);

          this.maximizeDetailedChartData.series = [];
          this.maximizeDetailedChartData.yAxis = [];

          let signals = Object.keys(res.data.data.details.signals),
              yAxisTop = {
                title: {
                  text: '',
                  align: 'high'
                },
                height: '45%'
              },
              yAxisBottom = {
                title: {
                  text: 'Running Hours',
                  align: 'high'
                },
                min: 0,
                top: '55%',
                height: '45%',
                offset: 0
              },
              opposite_threshold = Math.ceil(signals.length / 2);


          signals.map((item) => {
            let parameterAxis = JSON.parse(JSON.stringify(yAxisTop));
            parameterAxis.title.text = res.data.data.details.signals[item].title;
            parameterAxis.opposite = this.maximizeDetailedChartData.yAxis.length >= opposite_threshold;

            this.maximizeDetailedChartData.yAxis.push(parameterAxis)
            this.maximizeDetailedChartData.series.push({
              name: res.data.data.details.signals[item].title,
              animation: false,
              data: res.data.data.details.signals[item].values,
              size: '100%',
              innerSize: '70%',
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              },
              yAxis: this.maximizeDetailedChartData.yAxis.length - 1
            });
          });

          this.maximizeDetailedChartData.yAxis.push(yAxisBottom)
          Object.keys(res.data.data.events).map((item) => {
            this.maximizeDetailedChartData.series.push({
              name: res.data.data.events[item].title,
              animation: false,
              data: res.data.data.events[item].values,
              size: '100%',
              innerSize: '70%',
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              },
              yAxis: this.maximizeDetailedChartData.yAxis.length - 1
            });
          });
        }

        this.details_loading = false;
      }).catch(() => {
        this.details_loading = false;
      })
    },
    toggleDetailsTab(status) {
      this.selectedDetailedView = status;
    },
    openSignalsEdit() {
      this.edit_visible_signals = true;
      this.disable_edit_signals_btn = true;
      this.selected_signals_bp = JSON.parse(JSON.stringify(this.selected_signals));
    },
    cancelSignalEdit() {
      this.disable_edit_signals_btn = false
      this.edit_visible_signals = false
      this.selected_signals = JSON.parse(JSON.stringify(this.selected_signals_bp));
    },
    submitSignalEdit() {
      let selected_signal_parameters = Object.keys(this.available_signals).filter((parameter) => {
        return this.selected_signals.indexOf(this.available_signals[parameter]) > -1;
      });

      this.loadDataDetails(selected_signal_parameters).then(() => {
        this.disable_edit_signals_btn = false
        this.edit_visible_signals = false
      })
    }
  },
  mounted() {
    this.setTableHeight();
    this.setTasksDataSource();
  },
  computed: {
  },
  watch: {
    period: function () {
      this.setTasksDataSource();
    },
    available_signals: {
      handler: function () {
        for (var i = 0; i <= 5; i++) {
          this.available_signals_holders[i] = Object.values(this.available_signals).filter((item, index) => {
            return this.selected_signals.indexOf(item) < 0 || this.selected_signals[i] == item
          });
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style>
#maintenance_tasks_table .dx-master-detail-cell {
  padding: 0 !important;
}

.align_bottom[role="columnheader"] .dx-datagrid-text-content {
  padding-top: 2em;
}

#rhModalTabs .v-tabs__item.activeTab {
  border-bottom: 2px solid rgb(144, 170, 218);
}
</style>